import React from 'react';
import './style.sass';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';
const DiagrammCase = ({ params, className = '' }) => {
    return (
        <FullWrapper className={className}>
            <div className="diagramm-case">
                {params.title && <div className="diagramm-case__title">{params.title}</div>}
                <div className="diagramm-case__image">
                    <img src={params.image} alt={params.title} />
                </div>
            </div>
        </FullWrapper>
    );
};

export default DiagrammCase;
